import { Backdrop, Box, Fade, Grid, Modal, Typography } from "@mui/material";

const style = {
  position: "absolute",
  top: "40%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 600,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  display: "flex",
  justifyContent: "center",
};

export const ModalCertificadoEnUso = ({ open, handleClose, items }) => {
  const partes = items ?? [];

  return (
    <Modal
      aria-labelledby="certificado-en-uso-titulo"
      aria-describedby="certificado-en-uso-descripcion"
      open={open}
      onClose={handleClose}
      closeAfterTransition
      slots={{ backdrop: Backdrop }}
      slotProps={{
        backdrop: {
          timeout: 500,
        },
      }}
    >
      <Fade in={open}>
        <Box sx={style}>
          <Grid container spacing={0}>
            <Grid
              item
              xs={12}
              sx={{ p: 0, mb: 2, pr: 1 }}
              className="center_item"
            >
              <Typography
                id="certificado-en-uso-titulo"
                variant="h6"
                component="h2"
              >
                Certificado aún en uso
              </Typography>
            </Grid>
            <Grid
              item
              xs={12}
              sx={{ p: 0, mb: 2, pr: 1 }}
              className="center_item"
            >
              <span id="certificado-en-uso-descripcion">
                El certificado sigue ligado a la ruta de una parte. Para
                eliminarlo, primero reemplázalo en esa parte:
              </span>
            </Grid>
            <div style={{ maxHeight: 300, overflowY: "scroll", width: "100%" }}>
              {partes.map((item) => (
                <Grid
                  item
                  xs={12}
                  key={`${item?.part_codigoentrada}-${item?.part_nombre}`}
                  sx={{ display: "flex", justifyContent: "left", mb: 1 }}
                >
                  <span>
                    {item?.part_codigoentrada} - {item?.part_nombre}
                  </span>
                </Grid>
              ))}
            </div>
          </Grid>
        </Box>
      </Fade>
    </Modal>
  );
};
